<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-card class="ma-1">
          <!-- inner content -->
          <v-container grid-list-md fluid>
            <v-layout row wrap>
              <v-icon color="blue darken-2" size="60">description</v-icon>
              <h3>Forms : {{totalForm}}</h3>
            </v-layout>
          </v-container>

          <!-- inner content end -->
        </v-card>

        <v-card class="ma-1">
          <!-- inner content -->
          <v-container grid-list-md fluid>
            <v-layout row wrap>
              <v-icon color="blue darken-2" size="60">assignment</v-icon>
              <h3>Data Collected : {{totalData}}</h3>
            </v-layout>
          </v-container>
          <!-- inner content end -->
        </v-card>

        <v-card class="ma-1">
          <!-- inner content -->
          <v-container grid-list-md fluid>
            <v-layout row wrap>
              <v-icon color="blue darken-2" size="60">assignment</v-icon>
              <h3>Users : {{totalUser}}</h3>
            </v-layout>
          </v-container>
          <!-- inner content end -->
        </v-card>

        <!--         
          <v-card class="pa-0 ma-0">
            <v-card-title  class="headline font-weight-bold">            
                <v-icon color="green darken-2" size="60">assignment</v-icon>Data Collected :{{totalData}} 54            
            </v-card-title>
        </v-card>-->

        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-card class="ma-1">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Data collected by users</div>
                </div>
              </v-card-title>
              <v-card-text>
                <apexchart width="500" type="bar" :options="options" :series="userSeries"></apexchart>
              </v-card-text>
            </v-card>

            <v-card class="ma-1">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Form Responses</div>
                </div>
              </v-card-title>
              <v-card-text>
                <apexchart width="500" type="bar" :options="options" :series="formSeries"></apexchart>
              </v-card-text>
            </v-card>

            <v-card class="ma-1">
              <v-card-title primary-title>
                <div>
                  <div class="headline">Collection trend</div>
                </div>
              </v-card-title>
              <v-card-text>
                <apexchart width="500" type="bar" :options="options" :series="trendSeries"></apexchart>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-container>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import config from "../config.js";
const serverHost = config.backendServerHost;
import apexchart from "vue-apexcharts";

export default {
  name: "home",
  components: {
    apexchart
  },
  mounted() {
    this.loaddata();
  },
  data() {
    return {
      totalForm: "" + 0,
      totalData: "" + 0,
      totalUser: "" + 0,
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        }
      },
      userSeries: [],
      formSeries: [],
      trendSeries: [],
      series: [{
            name: 'PRODUCT A',
            data: [44, 55, 41, 67, 22, 43, 21, 49]
          }, {
            name: 'PRODUCT B',
            data: [13, 23, 20, 8, 13, 27, 33, 12]
          }, {
            name: 'PRODUCT C',
            data: [11, 17, 15, 15, 21, 14, 15, 13]
          }]
    };
  },
  methods: {
    loaddata() {
      //send request
      this.$axios
        .get(serverHost + "/reports/get")
        .then(response => {
          console.log(response);

          //user data :  userSeries: [ { data: [ { x: "data1", y: 54 }, { x: "data2", y: 66 } ] } ]

          if (response.status == 200) {
            this.totalForm = response.data.summary[0].totalForms;
            this.totalData = response.data.summary[0].totalData;
            this.totalUser = response.data.summary[0].totalUsers;
            // this.userSeries[0].data= response.data.userdata;
            this.formSeries = [{ data: response.data.formdata }];
            this.userSeries = [{ data: response.data.userdata }];
            this.trendSeries = [{ data: response.data.dataCollection }];
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
